/**
 * @type {import('@mui/material/styles').ThemeOptions}
 */
import { createTheme } from "@mui/material/styles";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#0093f1",
      contrastText: "#121212",
    },
    secondary: {
      main: "#9d4dff", // Purple accent
    },
    background: {
      default: "1a1a1a",
      paper: "#2e2e2f", // Slightly lighter surface
    },
    text: {
      primary: "#e0e0e0", // Off-white text
      secondary: "#888888", // Gray text
    },
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          minWidth: "120px", // Set minimum width
          "&:focus": {
            backgroundColor: "transparent", // Remove focus background
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          maxHeight: "200px", // Limit dropdown height
          width: "250px", // Set fixed width
          backgroundColor: "#2a2a2a", // Match dark theme
          border: "1px solid #3a3a3a",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
          "&::-webkit-scrollbar": {
            // Custom scrollbar
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#00ffcc",
          },
        },
        list: {
          padding: "8px 0", // Reduce padding
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          minHeight: "32px", // Reduce item height
          fontSize: "0.875rem", // Smaller text
          "&:hover": {
            backgroundColor: "rgba(0, 255, 204, 0.1)", // Subtle hover
          },
          "&.Mui-selected": {
            backgroundColor: "rgba(0, 255, 204, 0.15)",
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          marginTop: "4px", // Add spacing from input
          transformOrigin: "top left !important", // Better positioning
        },
      },
    },
  },
});

export default darkTheme;
